import React from 'react';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getCombinatorialWells } from 'client/app/components/Parameters/PlateLayout/lib/combinatorialWellGenerationUtils';
import { reorderWellLocationOnDeckItem } from 'client/app/components/Parameters/PlateLayout/lib/WellAvailability';
import { usePlateLayoutEditorContext } from 'client/app/components/Parameters/PlateLayout/PlateLayoutEditorProvider';
import { shuffle } from 'common/lib/arrays';
import { WellSortMode } from 'common/types/plateAssignments';
import Button from 'common/ui/components/Button';
import IconWithPopover from 'common/ui/components/IconWithPopover';

export function CombinatorialTools() {
  const {
    plateType,
    plateAssignment,
    selectedWells,
    setSelectedWells,
    isEditingCombinatorialWells,
    setIsEditingCombinatorialWells,
    setCombinatorialModeWells,
  } = usePlateLayoutEditorContext();

  if (!isEditingCombinatorialWells) {
    return (
      <>
        <Button
          variant="secondary"
          size="small"
          startIcon={<EditIcon />}
          onClick={() => setIsEditingCombinatorialWells(true)}
        >
          Edit well availability
        </Button>
        <IconWithPopover
          icon={<HelpIcon color="inherit" />}
          popoverContent={
            <Typography variant="caption">
              Edit the wells that are available across all plates. Synthace will then add
              the combinatorially generated mixtures to these wells in the number order
              shown.
            </Typography>
          }
        />
      </>
    );
  }

  return (
    <Stack
      margin="auto"
      direction="row"
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
      gap={4}
    >
      <Typography variant="h5">Selection tools: </Typography>
      <Button
        variant="secondary"
        size="small"
        startIcon={<ArrowForwardIcon />}
        onClick={() =>
          setSelectedWells(
            reorderWellLocationOnDeckItem([...selectedWells], WellSortMode.BY_ROW),
          )
        }
      >
        Row-wise
      </Button>
      <Button
        variant="secondary"
        size="small"
        startIcon={<ArrowDownwardIcon />}
        onClick={() =>
          setSelectedWells(
            reorderWellLocationOnDeckItem([...selectedWells], WellSortMode.BY_COLUMN),
          )
        }
      >
        Column-wise
      </Button>
      <Button
        variant="secondary"
        size="small"
        startIcon={<ShuffleIcon />}
        onClick={() => setSelectedWells(shuffle([...selectedWells]))}
      >
        Randomize
      </Button>
      <Divider orientation="vertical" flexItem />
      <Button
        variant="primary"
        color="primary"
        size="small"
        onClick={() => {
          setCombinatorialModeWells(selectedWells);
          setIsEditingCombinatorialWells(false);
        }}
      >
        Save
      </Button>
      <Button
        variant="secondary"
        color="primary"
        size="small"
        onClick={() => {
          setSelectedWells(getCombinatorialWells(plateAssignment, plateType!));
          setIsEditingCombinatorialWells(false);
        }}
      >
        Cancel
      </Button>
    </Stack>
  );
}
